import { Injectable } from '@angular/core';
import { ModalService } from '../../../../utils/modals/modals.service';
import { KzModal } from '../../../../kz-ui/ui/modal/kz-modal';
import { ProTenderFormComponent } from './pro-tender-form/pro-tender-form.component';
@Injectable()
export class ProTenderService {

  constructor(
    private readonly _modalService: ModalService,
  ) {
  }

  openTenderRequest(tenderProject: string): void {
    const modal: KzModal<ProTenderFormComponent> = this._modalService.open(ProTenderFormComponent, { size: 'fullscreen', backdrop: true, closeButton: true });
    modal.componentRef.instance.tenderProject = tenderProject;
  }
}
